<template>
  <div class="video mx-auto">
    <div class="embed-responsive embed-responsive-16by9">
      <iframe
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen="true"
        class="embed-responsive-item"
        frameborder="0"
        :src="videoUrl"
        :title="videoTitle">
      </iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Video',
  props: {
    videoUrl: String,
    videoTitle: String,
  },
}
</script>

<style scoped lang="scss">
@media screen and (min-width: 768px) {
  .video {
    width: calc(64vh * (16/9));
    max-width: 100%;
  }
}
</style>
